import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const PlusCircleIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path stroke="currentcolor" d="M2 16C2 8.29 8.234 2 16 2c7.71 0 14 6.29 14 14 0 7.766-6.29 14-14 14-7.766 0-14-6.234-14-14Z" />
    <path stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M10 16.01H22.02M16.01 22.02V10" />
  </IconV2>
);

export default PlusCircleIcon;
